var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );
dependencies["front/components/BasePopup/BasePopup.jinja"] = require( "front/components/BasePopup/BasePopup.jinja" );
dependencies["front/components/AwardsADGWinnersList/AwardsADGWinnersList.jinja"] = require( "front/components/AwardsADGWinnersList/AwardsADGWinnersList.jinja" );




var shim = require("/var/www/django/adg.org/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/pages/AwardsADGWinnersPopup/AwardsADGWinnersPopup.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/pages/AwardsADGWinnersPopup/AwardsADGWinnersPopup.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n";
env.getTemplate("front/components/BasePopup/BasePopup.jinja", true, "assets/app/front/pages/AwardsADGWinnersPopup/AwardsADGWinnersPopup.jinja", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
parentTemplate = t_5
for(var t_4 in parentTemplate.blocks) {
context.addBlock(t_4, parentTemplate.blocks[t_4]);
}
output += "\n\n";
env.getTemplate("front/components/AwardsADGWinnersList/AwardsADGWinnersList.jinja", false, "assets/app/front/pages/AwardsADGWinnersPopup/AwardsADGWinnersPopup.jinja", false, function(t_8,t_7) {
if(t_8) { cb(t_8); return; }
t_7.getExported(function(t_9,t_7) {
if(t_9) { cb(t_9); return; }
if(Object.prototype.hasOwnProperty.call(t_7, "AwardsADGWinnersList")) {
var t_10 = t_7.AwardsADGWinnersList;
} else {
cb(new Error("cannot import 'AwardsADGWinnersList'")); return;
}
context.setVariable("AwardsADGWinnersList", t_10);
output += "\n\n";
(parentTemplate ? function(e, c, f, r, cb) { cb(""); } : context.getBlock("popupContent"))(env, context, frame, runtime, function(t_12,t_11) {
if(t_12) { cb(t_12); return; }
output += t_11;
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
function b_popupContent(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var frame = frame.push(true);
output += "\n    <div class=\"AwardsADGWinnersPopup\">\n        <div class=\"AwardsADGWinnersPopup-headerImage\" data-animation=\"1\" data-animation-type=\"bubble-down\" data-animation-state=\"initial\">\n            ";
if(1) {
output += "\n                <div class=\"AwardsADGWinnersPopup-headerImageWrapper\">\n                    <img src=\"";
output += runtime.suppressValue((lineno = 10, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, ["img/awardsADGWinnersPopup/header.jpg"])), env.opts.autoescape);
output += "\"\n                      srcset=\"";
output += runtime.suppressValue((lineno = 11, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, ["img/awardsADGWinnersPopup/header.jpg"])), env.opts.autoescape);
output += " 1920w,\n                              ";
output += runtime.suppressValue((lineno = 12, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, ["img/awardsADGWinnersPopup/header.jpg"])), env.opts.autoescape);
output += " 1680w,\n                              ";
output += runtime.suppressValue((lineno = 13, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, ["img/awardsADGWinnersPopup/header.jpg"])), env.opts.autoescape);
output += " 1366w,\n                              ";
output += runtime.suppressValue((lineno = 14, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, ["img/awardsADGWinnersPopup/header.jpg"])), env.opts.autoescape);
output += " 920w,\n                              ";
output += runtime.suppressValue((lineno = 15, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "static"), "static", context, ["img/awardsADGWinnersPopup/header.jpg"])), env.opts.autoescape);
output += " 680w\"\n                      sizes=\"(max-width: 759px) 1, ";
output += "\n                             (min-width: 760px) and (max-width: 979px) 681, ";
output += "\n                             calc(100% - 240px)\" ";
output += "\n                      alt=\"\">\n                </div>\n            ";
;
}
else {
output += "\n                <div class=\"AwardsADGWinnersPopup-headerImagePattern\">\n                    ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"title")), env.opts.autoescape);
output += "\n                </div>\n            ";
;
}
output += "\n        </div>\n\n        <div class=\"AwardsADGWinnersPopup-yearSelector\">\n            <div class=\"AwardsADGWinnersPopup-yearSelectorText\">Select Year: <span>";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"year"), env.opts.autoescape);
output += " / ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"title")), env.opts.autoescape);
output += "</span></div>\n            <div class=\"AwardsADGWinnersPopup-yearSelectorIcon\">\n                ";
output += runtime.suppressValue((lineno = 31, colno = 38, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "macros")),"svgSprite"), "macros[\"svgSprite\"]", context, ["arrow-down","0 0 22 12",runtime.makeKeywordArgs({"caller": (function (){var macro_t_13 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_14 = "";;
frame = frame.pop();
return new runtime.SafeString(t_14);
});
return macro_t_13;})()})])), env.opts.autoescape);
output += "\n            </div>\n            <div class=\"AwardsADGWinnersPopup-yearSelectorDropdown\">\n                <div class=\"AwardsADGWinnersPopup-yearSelectorDropdownWrapper\">\n                    ";
frame = frame.push();
var t_17 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"years");
if(t_17) {t_17 = runtime.fromIterator(t_17);
var t_16 = t_17.length;
for(var t_15=0; t_15 < t_17.length; t_15++) {
var t_18 = t_17[t_15];
frame.set("year", t_18);
frame.set("loop.index", t_15 + 1);
frame.set("loop.index0", t_15);
frame.set("loop.revindex", t_16 - t_15);
frame.set("loop.revindex0", t_16 - t_15 - 1);
frame.set("loop.first", t_15 === 0);
frame.set("loop.last", t_15 === t_16 - 1);
frame.set("loop.length", t_16);
output += "\n                        <a href=\"";
output += runtime.suppressValue((lineno = 36, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:awards_adg_winners-popup",runtime.makeKeywordArgs({"args": [runtime.memberLookup((t_18),"typ"),runtime.memberLookup((t_18),"year")]})])), env.opts.autoescape);
output += "\" class=\"";
if((runtime.memberLookup((t_18),"year") == runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"year"))) {
output += "AwardsADGWinnersPopup-yearSelectorDropdownItem--active";
;
}
output += "\">";
output += runtime.suppressValue(runtime.memberLookup((t_18),"year"), env.opts.autoescape);
output += " / ";
output += runtime.suppressValue(env.getFilter("safe").call(context, runtime.memberLookup((t_18),"title")), env.opts.autoescape);
output += "</a>\n                    ";
;
}
}
frame = frame.pop();
output += "\n                </div>\n\n            </div>\n        </div>\n\n        <div class=\"AwardsADGWinnersPopup-title\"><a href=\"";
output += runtime.suppressValue((lineno = 43, colno = 61, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "url"), "url", context, ["front:awards_adg"])), env.opts.autoescape);
output += "\">ADG Awards</a></div>\n        <div class=\"AwardsADGWinnersPopup-caption\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"caption"), env.opts.autoescape);
output += "</div>\n\n        <div class=\"AwardsADGWinnersPopup-content\">\n\n            ";
frame = frame.push();
var t_21 = runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "popup")),"categories");
if(t_21) {t_21 = runtime.fromIterator(t_21);
var t_20 = t_21.length;
for(var t_19=0; t_19 < t_21.length; t_19++) {
var t_22 = t_21[t_19];
frame.set("category", t_22);
frame.set("loop.index", t_19 + 1);
frame.set("loop.index0", t_19);
frame.set("loop.revindex", t_20 - t_19);
frame.set("loop.revindex0", t_20 - t_19 - 1);
frame.set("loop.first", t_19 === 0);
frame.set("loop.last", t_19 === t_20 - 1);
frame.set("loop.length", t_20);
output += "\n                ";
output += runtime.suppressValue((lineno = 49, colno = 37, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "AwardsADGWinnersList"), "AwardsADGWinnersList", context, [runtime.makeKeywordArgs({"data": t_22})])), env.opts.autoescape);
output += "\n            ";
;
}
}
frame = frame.pop();
output += "\n        </div>\n    </div>\n";
cb(null, output);
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
b_popupContent: b_popupContent,
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/pages/AwardsADGWinnersPopup/AwardsADGWinnersPopup.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/AwardsADGWinnersPopup/AwardsADGWinnersPopup.jinja
// module id = 523
// module chunks = 0